<ng-scrollbar visibility="hover">
  <div class="d-flex flex-column ps-4 pe-4 pt-4 pb-5">
    <h1>{{ 'memberOverview.title' | translate }}</h1>
    <div class="d-flex justify-content-end">
      <button class="toggle-button poster" [class.active]="memberPosterView" (click)="toggleMemberView(true)">
        <img [src]="'assets/svg-icons/member-button-poster_' + memberPosterView + '.svg'" alt="member button poster icon">
      </button>
      <button class="toggle-button list" [class.active]="!memberPosterView" (click)="toggleMemberView(false)">
        <img [src]="'assets/svg-icons/member-button-list_' + !memberPosterView + '.svg'" alt="member button list icon">
      </button>
    </div>


    <ng-container *ngIf="(companyPages$|async) as companies; else loading">
      <div *ngIf="memberPosterView" class="d-flex card-wrapper">
        <section>
                <ng-container *ngIf="this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_UNDERWRITER).length > 0">
                  <mat-accordion class="accordion-container" [multi]="true" displayMode="flat">
                    <mat-expansion-panel [togglePosition]="'before'" [expanded]="true">
                      <mat-expansion-panel-header [@.disabled]="true">
                        <span class="title">{{'memberOverview.underwriters' | translate}} ({{this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_UNDERWRITER).length}})</span>
                      </mat-expansion-panel-header>

                      <div class="d-flex flex-wrap contact-person-outer-container">
                        <ng-container *ngFor="let company of this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_UNDERWRITER)">
                          <ng-container *ngTemplateOutlet="companyShow; context:{company: company, role: Roles.ROLE_UNDERWRITER}"></ng-container>
                        </ng-container>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </ng-container>
              </section>
              <section>
                <ng-container *ngIf="this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_EXPERT).length > 0">
                  <mat-accordion class="accordion-container" [multi]="true" displayMode="flat">
                    <mat-expansion-panel [togglePosition]="'before'" [expanded]="true">
                      <mat-expansion-panel-header [@.disabled]="true">
                        <span class="title">{{'memberOverview.experts' | translate}} ({{this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_EXPERT).length}})</span>
                      </mat-expansion-panel-header>

                      <div class="d-flex flex-wrap contact-person-outer-container">
                        <ng-container *ngFor="let company of this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_EXPERT)">
                          <ng-container *ngTemplateOutlet="companyShow; context:{company: company, role: Roles.ROLE_EXPERT}"></ng-container>
                        </ng-container>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </ng-container>
              </section>
              <section>
                <ng-container *ngIf="this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_BROKER).length > 0">
                  <mat-accordion class="accordion-container" [multi]="true" displayMode="flat">
                    <mat-expansion-panel [togglePosition]="'before'" [expanded]="true">
                      <mat-expansion-panel-header [@.disabled]="true">
                        <span class="title">{{'memberOverview.brokers' | translate}} ({{this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_BROKER).length}})</span>
                      </mat-expansion-panel-header>
                      <div class="d-flex flex-wrap contact-person-outer-container">
                        <ng-container *ngFor="let company of this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_BROKER)">
                          <ng-container *ngTemplateOutlet="companyShow; context:{company: company, role: Roles.ROLE_BROKER}"></ng-container>
                        </ng-container>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </ng-container>
              </section>
              <section>
                <ng-container *ngIf="this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_INSURER).length > 0">
                  <mat-accordion class="accordion-container" [multi]="true" displayMode="flat">
                    <mat-expansion-panel [togglePosition]="'before'" [expanded]="true">
                      <mat-expansion-panel-header [@.disabled]="true">
                        <span class="title">{{'memberOverview.insurers' | translate}} ({{this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_INSURER).length}})</span>
                      </mat-expansion-panel-header>
                      <div class="d-flex flex-wrap contact-person-outer-container">
                        <ng-container *ngFor="let company of this.filterByRole(companiesWithRepresentatives(companies), Roles.ROLE_INSURER)">
                          <ng-container *ngTemplateOutlet="companyShow; context:{company: company, role: Roles.ROLE_INSURER}"></ng-container>
                        </ng-container>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </ng-container>
              </section>
            </div>

            <div *ngIf="!memberPosterView" class="offer-overview">
                <table *ngIf="companiesWithRepresentatives(companies).length > 0" aria-label="List of companies" mat-table [dataSource]="companiesWithRepresentatives(companies)" class="offers-table">

                  <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef class="text-start"> {{'memberOverview.role'|translate}}</th>
                    <td mat-cell class="text-start" *matCellDef="let company">
                      <ng-container *ngIf="company.users && company.users.length > 0 && hasRepresentativeRole(company.users)">
                        {{'companyRole.' + company.companyRole | translate}}
                       </ng-container>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="companyName">
                    <th mat-header-cell *matHeaderCellDef class="text-start"> {{'memberOverview.companyName'|translate}}</th>
                    <td mat-cell class="text-start" *matCellDef="let company">
                       <ng-container *ngIf="company.users && company.users.length > 0 && hasRepresentativeRole(company.users)">
                          <div class="d-flex all-cursor-pointer user-pod"
                           (click)="navigateToCompanyProfile(company.companyId)">
                        <img class="custom-profile-picture me-2 rounded-circle"
                             [src]="(companyService.getLogo(company.companyId) |async) ?? 'assets/img/profile/default-profile-icon.png'"
                             alt="private"/>

                        <div class="d-flex flex-column justify-content-center">
                          <a [routerLink]="'/'+ Route.COMPANY_PROFILE+'/'+ company.companyId"
                             class="dark-text small-text company-label">{{company.name}}</a>
                        </div>
                      </div>

                      </ng-container>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef class="text-start"> {{'memberOverview.companyAddress'|translate}}</th>

                    <td mat-cell class="text-start" *matCellDef="let company">
                    <ng-container *ngIf="company.users && company.users.length > 0 && hasRepresentativeRole(company.users)">
                          {{ company.street }} {{company.houseNumber}}, {{company.postalCode}} {{company.location}}, {{'countryCodes.' + company.countryCode | translate}}
                      </ng-container>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="representatives">
                    <th mat-header-cell *matHeaderCellDef class="text-start"> {{'memberOverview.representatives'|translate}}</th>
                    <td mat-cell class="text-start" *matCellDef ="let company">
                      <ng-container *ngIf="company.users && company.users.length > 0 && hasRepresentativeRole(company.users)">
                        <ul>
                        <ng-container *ngFor="let user of company.users">

                            <ng-container *ngIf="user.isRepresentative">
                              <li>
                                <ng-container>
                                  <a [routerLink]="'/'+ Route.USER_PAGE+'/'+ user.id">
                                    {{user.firstName}} {{user.lastName}}
                                  </a>
                                </ng-container>
                              </li>
                            </ng-container>

                          </ng-container>
                        </ul>
                      </ng-container>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="phoneNumber">
                    <th mat-header-cell *matHeaderCellDef class="text-start"> {{'memberOverview.phoneNumber'|translate}}</th>
                    <td mat-cell class="text-start" *matCellDef="let company">
                    <ng-container *ngIf="company.users && company.users.length > 0 && hasRepresentativeRole(company.users)">
                        <ul>
                          <ng-container *ngFor="let user of company.users">

                            <ng-container *ngIf="user.isRepresentative && user.telephoneNumber">
                              <li>
                                <ng-container> {{user.telephoneNumber}} </ng-container>
                              </li>
                            </ng-container>

                          </ng-container>
                        </ul>
                      </ng-container>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef class="text-start"> {{'memberOverview.emailAddress'|translate}}</th>

                    <td mat-cell class="text-start" *matCellDef="let company">
                    <ng-container *ngIf="company.users && company.users.length > 0 && hasRepresentativeRole(company.users)">
                        <ul>
                          <ng-container *ngFor="let user of company.users">

                              <ng-container *ngIf="user.isRepresentative">
                                <li>
                                <ng-container>
                                  <a [href]="'mailto:'+user.email">
                                    {{user.email}}
                                  </a>
                                </ng-container>
                               </li>
                              </ng-container>

                          </ng-container>
                        </ul>
                      </ng-container>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let company">
                      <ng-container *ngIf="company.users && company.users.length > 0 && hasRepresentativeRole(company.users)">

                      <mat-icon class="main-blue cursor-pointer"
                                (click)="navigateToCompanyProfile(company.companyId)">
                        arrow_forward
                      </mat-icon>
                      </ng-container>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: false"></tr>
                  <ng-container>
                    <tr mat-row
                        *matRowDef="let row; columns: displayedColumns;">
                    </tr>
                  </ng-container>

                </table>
              <!--  Add space so the popover is not hidden by overflow-->

            </div>
          </ng-container>

  </div>
</ng-scrollbar>


<ng-template #companyShow let-company="company" let-role="role">


  <div class="contact-person-container">
    <img class="profile-picture"
         [src]="(companyService.getLogo(company.companyId) |async) ?? 'assets/img/profile/default-profile-icon.png'"
         alt=""/>
    <span class="name">{{company.name}} </span>
    <div class="type" [class.visibility-hidden]="!role">
      <span>
        <ng-container *ngIf="role">{{'companyRole.' + role | translate}}</ng-container>
      </span>
    </div>
    <span class="seat-number"
           [class.visibility-hidden]="!company.seatNumber">{{company.seatNumber ? company.seatNumber : 'none'}}</span>
    <button class="blue-border"
            (click)="navigateToCompanyProfile(company.companyId)">{{'companyPage.toProfile'|translate}}
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>

</ng-template>
<ng-template #loading>
  <div class="d-flex w-100 h-100 align-items-center justify-content-center">
    <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
  </div>
</ng-template>
